import styled from 'styled-components';

export const HdrContainer = styled.div`
  height: 342px;
  position: relative;
  margin-bottom: 44px;
  background: linear-gradient(70deg, #18181f -0.89%, #6d1dbc 99.74%);

  &::before {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    width: 575px;
    height: 80px;
    background: url('https://assets-gos3.goibibo.com/myp_incentive_thundering-1697778056.png')
      bottom right no-repeat;
    background-size: cover;
  }
`;
export const SubText = styled.p`
  color: #ffffff;
  font-size: 18px;
  margin-top: 8px;
`;
export const HdrDetailContainer = styled.div`
  display: flex;
  position: relative;
  width: 1200px;
  margin: 0px auto 0px auto;
  justify-content: space-between;
  padding: 22px 0px 0px 0px;
`;

export const HdrBannerTxt = styled.p`
  font-size: 32px;
  font-style: italic;
  line-height: 40px;
  color: #fff;
  font-weight: 800;
`;

export const ExclOfferImg = styled.img`
  width: 575px;
  height: 290px;
`;

export const HdrBannerInfo = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  margin-top: 10px;
`;

export const ImgTxt = styled.p`
  font-size: 16px;
  font-style: italic;
  line-height: 20px;
  color: #0d2058;
  margin-left: 72px;
`;

export const ImgSubTxt = styled.p`
  font-size: 22px;
  line-height: 24px;
  color: #fff;
  font-weight: 900;
  margin-left: 72px;
  font-style: italic;
  margin-top: 6px;
`;

export const OfferImgPersuasion = styled.div`
  margin-top: 32px;
  padding: 15px 0px 0px 10px;
  width: 400px;
  height: 78px;
  background: url('https://assets-gos3.goibibo.com/myp_incentive_offer_period-1697777206.png')
    bottom right no-repeat;
  background-size: cover;
`;

export const SubHeadingOfferImg = styled.img`
  width: 600px;
  height: auto;
  margin-top: 32px;
`;
